module.exports = __webpack_public_path__ + "static/media/system-smart.90b3b70c.svg";